import Splide from '@splidejs/splide';

document.addEventListener('DOMContentLoaded', function () {
    const initializeBlock = function() {
        const sliders = document.querySelectorAll('.home-skincare__slider.splide');

        if (sliders.length > 0) {
            sliders.forEach(function (slider) {
                const options = JSON.parse(slider.getAttribute('data-splide'));
                const list = slider.querySelector('.procedures-list');
                if (list) {
                    list.classList.add('splide__list');
                    list.querySelectorAll('li').forEach(function (item) {
                        item.classList.add('splide__slide', 'home-skincare__slide');
                    });
                }
                const splide = new Splide(slider, options);
                const progressBar = slider.closest('.home-skincare__carousel')?.querySelector('.home-skincare__progress__bar');

                const updateProgress = function () {
                    if (!progressBar) {
                        return;
                    }

                    const end = splide.Components?.Controller?.getEnd
                        ? splide.Components.Controller.getEnd()
                        : Math.max(0, splide.length - (splide.options.perPage || 1));
                    const steps = Math.max(1, end + 1);
                    const trackWidth = progressBar.parentElement ? progressBar.parentElement.clientWidth : 0;
                    const stepWidth = trackWidth / steps;
                    progressBar.style.width = `${stepWidth}px`;
                    progressBar.style.transform = `translateX(${splide.index * stepWidth}px)`;
                };

                splide.on('mounted move resize updated', updateProgress);
                splide.mount();
                updateProgress();
            });
        }
    }

    if (window.acf) {
        // Initialize dynamic block preview (editor).
        window.acf.addAction('render_block_preview/type=home-skincare', initializeBlock);
    } else {
        // Initialize on the frontend.
        initializeBlock();
    }
});
